var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronSortVertical = function SvgChevronSortVertical(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71717A",
    d: "M8.617 2.885a.981.981 0 0 0-1.234 0c-.975.785-1.845 1.7-2.587 2.72a.667.667 0 0 0 .587 1.06c1.742-.13 3.492-.13 5.234 0a.667.667 0 0 0 .587-1.06 14.234 14.234 0 0 0-2.587-2.72ZM5.383 9.335a.667.667 0 0 0-.587 1.06 14.237 14.237 0 0 0 2.587 2.72c.361.291.873.291 1.234 0 .975-.784 1.845-1.7 2.587-2.72a.667.667 0 0 0-.587-1.06c-1.742.13-3.492.13-5.234 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronSortVertical);
export default ForwardRef;